import "src/BrowserAgent";
import React from "react";
import { createRoot } from "react-dom/client";

import { OriginThemeProvider } from "@origin-digital/ods-core";
import { BrowserRouter } from "react-router-dom";

import { AppContextProvider } from "src/context/AppContext";
import { ErrorWrapper } from "src/components/ErrorWrapper";

import { GlobalResponsiveGuard } from "src/components/ResponsiveGuard";
import Root from "./root";
import { AuthProvider } from "./Modules/Auth/AuthProvider";

const App = () => (
  <OriginThemeProvider>
    <BrowserRouter basename="/ocportal">
      <AuthProvider>
        <AppContextProvider>
          <GlobalResponsiveGuard>
            <ErrorWrapper>
              <Root />
            </ErrorWrapper>
          </GlobalResponsiveGuard>
        </AppContextProvider>
      </AuthProvider>
    </BrowserRouter>
  </OriginThemeProvider>
);

const container = document.getElementById("app");

const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);
